export default __webpack_public_path__ + "static/newBg-21278ba5153aa78984ac25419aa7e77a.png";